import type { PropertyBase } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const propertyBaseSchema = z.object({
  id: z.string(),
  label: z.string().optional(),
  tip: z.string().optional(),
  required: z.boolean().optional(),
  placeholder: z.string().optional(),
  hide_condition: z.string().optional(),
}) as unknown as ToZod<PropertyBase>

export type PropertyBaseSchema = PropertyBase